/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type FreeTextbooksSyllabusSelectorTextbookSelectorQueryVariables = {
    curriculumId: string;
};
export type FreeTextbooksSyllabusSelectorTextbookSelectorQueryResponse = {
    readonly curriculum: {
        readonly title: string;
        readonly syllabuses: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly title: string;
                    readonly thumbnailImageUrl: string;
                    readonly topics: {
                        readonly totalCount: number;
                    };
                };
            }>;
        };
    } | null;
};
export type FreeTextbooksSyllabusSelectorTextbookSelectorQuery = {
    readonly response: FreeTextbooksSyllabusSelectorTextbookSelectorQueryResponse;
    readonly variables: FreeTextbooksSyllabusSelectorTextbookSelectorQueryVariables;
};



/*
query FreeTextbooksSyllabusSelectorTextbookSelectorQuery(
  $curriculumId: ID!
) {
  curriculum(id: $curriculumId) {
    title
    syllabuses {
      edges {
        node {
          id
          title
          thumbnailImageUrl
          topics {
            totalCount
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "curriculumId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "curriculumId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "FreeTextbookSyllabusConnection",
  "kind": "LinkedField",
  "name": "syllabuses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FreeTextbookSyllabusEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FreeTextbookSyllabus",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnailImageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FreeTextbookTopicConnection",
              "kind": "LinkedField",
              "name": "topics",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FreeTextbooksSyllabusSelectorTextbookSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookCurriculum",
        "kind": "LinkedField",
        "name": "curriculum",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FreeTextbooksSyllabusSelectorTextbookSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FreeTextbookCurriculum",
        "kind": "LinkedField",
        "name": "curriculum",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cbde2a5bb4743a20e2d74ee4f6d0e9ea",
    "id": null,
    "metadata": {},
    "name": "FreeTextbooksSyllabusSelectorTextbookSelectorQuery",
    "operationKind": "query",
    "text": "query FreeTextbooksSyllabusSelectorTextbookSelectorQuery(\n  $curriculumId: ID!\n) {\n  curriculum(id: $curriculumId) {\n    title\n    syllabuses {\n      edges {\n        node {\n          id\n          title\n          thumbnailImageUrl\n          topics {\n            totalCount\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '5d0c029595250ae6e4fdeff8b99a8f52';
export default node;
